export default "__VITE_ASSET__BIhm_Gh9__"